module.exports = __webpack_public_path__ + "static/media/bob-voyeur-exhibe-amateur.392f1925.gif";